// extracted by mini-css-extract-plugin
export default {"button":"rismlW","icon":"MZjLK3","text":"MlbU1R"};